import React, { useState } from "react";
import { getCallBack, UploadImage } from "../../api/api";
import toast from "react-hot-toast";

export default function PrescriptionUpload({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    file: null,
    prescription: "",
  });

  const [uploading, setUploading] = useState(false);

  const handleChange = async (e) => {
    const { name, value, files } = e.target;

    if (name === "file") {
      const file = files[0];
      if (!file) return;
      const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "application/pdf",
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only image and PDF files are allowed.");
      return;
    }
      setFormData({ ...formData, file });
      

      // upload immediately
      await uploadFile(file);
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // ✅ Upload API Call
  const uploadFile = async (file) => {
    try {

       console.log("Uploading filefff:", file); 
      setUploading(true);
      const fileExt = file.name.split('.').pop();
      const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, '').slice(8, 14);
      const renamedFileName = `pres_${timestamp}.${fileExt}`;

      // Create a new File object with the renamed file
      const renamedFile = new File([file], renamedFileName, { type: file.type });
      console.log(renamedFile, 'renamedFile');
      


      const formDataToSend = new FormData();
      formDataToSend.append("uploadImage", renamedFile); // binary file
      formDataToSend.append("imagePath", "upload/prescription/");

      // axios-based upload call
      const response = await UploadImage(formDataToSend);
      console.log("Upload response:", response);

      // ✅ handle Axios response structure
      if (response?.data) {
        setFormData((prev) => ({
          ...prev,
          prescription: response?.data?.uploadImage?.uploadImage || "",
        }));
        console.log("Upload response data:", formData);
        toast.success("File uploaded successfully!");
      } else {
        toast.error("File upload failed!");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("Something went wrong while uploading!");
    } finally {
      setUploading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      mobile: "",
      file: null,
      prescription: "",
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    const nameParts = formData.name.trim().split(" ");
    const first_name = nameParts[0] || "";
    const last_name = nameParts.slice(1).join(" ") || "";

    const payload = {
      first_name,
      last_name,
      phone_number: formData.mobile,
      prescription: formData?.prescription?.uploadImage || "",
    };

    try {
      const response = await getCallBack(payload);
      console.log("Form submitted successfully:", response);
      handleReset();
    //   setSuccessModal(true); 
    } catch (error) {
      console.error("Error submitting form:", error);
    //   alert("There was an error submitting the form. Please try again.");
    toast.error(error?.response?.data?.message || error?.message)
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "#cbe8e4ff",
          borderRadius: "8px",
          padding: "30px",
          width: "90%",
          maxWidth: "450px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
          position: "relative",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            background: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          ✕
        </button>

        {/* Heading */}
        <div>
          <h4
            style={{
              marginTop: 0,
              color: "#0FB7A4",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            UPLOAD PRESCRIPTION
          </h4>
          <h5
            style={{
              marginTop: "-10px",
              marginBottom: "20px",
              color: "#0FB7A4",
              fontWeight: "bold",
            }}
          >
            OUR CALL EXECUTIVE WILL CALL BACK SHORTLY.
          </h5>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Name */}
          <label style={{ display: "block", marginBottom: "5px", color: "#333" }}>
            Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginBottom: "15px",
              boxSizing: "border-box",
            }}
          />

          {/* Mobile */}
          <label style={{ display: "block", marginBottom: "5px", color: "#333" }}>
            Mobile No. <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            maxLength={10}
            required
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginBottom: "15px",
              boxSizing: "border-box",
            }}
          />

          {/* Upload Prescription */}
          <label style={{ display: "block", marginBottom: "5px", color: "#333" }}>
            Upload Prescription (PDF or Image) <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="file"
            name="file"
            accept=".pdf, image/*"
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "6px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginBottom: "15px",
              backgroundColor: "white",
              boxSizing: "border-box",
            }}
          />
          {formData.file && (
            <p style={{ fontSize: "13px", color: "#333", marginTop: "5px" }}>
              Selected file: <strong>{formData.file.name}</strong>
            </p>
          )}
          {uploading && (
            <p style={{ fontSize: "13px", color: "#0FB7A4" }}>Uploading...</p>
          )}

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              onClick={handleReset}
              style={{
                backgroundColor: "#706b6bff",
                color: "white",
                border: "none",
                padding: "10px 0",
                borderRadius: "4px",
                cursor: "pointer",
                width: "120px",
                textAlign: "center",
                fontSize: "15px",
              }}
            >
              Reset
            </button>
            <button
              type="submit"
              style={{
                backgroundColor: "#0FB7A4",
                color: "white",
                border: "none",
                padding: "10px 0",
                borderRadius: "4px",
                cursor: "pointer",
                width: "120px",
                textAlign: "center",
                fontSize: "15px",
              }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
